export const isAValidURL = (url: string): boolean => {
  const urlRegex =
    /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/;
  const matchResult = url.match(urlRegex);
  return Boolean(matchResult);
};

export const getFileNameFromURL = (url: string): string => {
  const URLLastPart = url.split("/").pop();
  const filename = URLLastPart ? URLLastPart.split("#")[0].split("?")[0] : "";
  return filename ? window.decodeURIComponent(filename) : "";
};

// Only http and https links are safe to open, preview or bind to href.
// Anything else, such as javascript:, could run script on our origin.
export const isSafeUrl = (url: string): boolean => {
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};

export const isAValidPathToTheLocalFile = (path: string): boolean => {
  const localFilePathRegex =
    /^(file:\/\/)?([-a-zA-Z0-9@:%._+~#=!&*' ()/\\]){1,}\.+([a-zA-Z]{1,})$/gi;
  // Reject any scheme other than file:, such as javascript:.
  // A single letter before the colon is a Windows drive, like C:
  const pathWithoutFilePrefix = path.replace(/^file:[/\\]{2}/i, "");
  if (/^[a-z][a-z0-9+.-]+:/i.test(pathWithoutFilePrefix)) {
    return false;
  }
  const matchResult = path.match(localFilePathRegex);
  return Boolean(matchResult);
};

export const isValidImageFileType = (type: string): boolean => {
  return (
    type === "image/png" ||
    type === "image/jpeg" ||
    type === "image/bmp" ||
    type === "image/gif"
  );
};

export const isValidCsvFileType = (type: string): boolean => {
  return type === "text/csv";
};

export const isValidXmlFileType = (type: string): boolean => {
  return type === "text/xml";
};

export default {
  isAValidURL,
  getFileNameFromURL,
  isAValidPathToTheLocalFile,
  isSafeUrl,
  isValidImageFileType,
  isValidCsvFileType,
  isValidXmlFileType
};
